export default __webpack_public_path__ + "static/media/MP_Skills_Dream-job_01.87988b0e.png";